import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { ModalUI } from '../../../common';

const ModalColocarRetirada = (props) => {
  let { handleSubmit, modalHandler, modal_state, form_state } = props;

  return (
    <ModalUI
      open={modal_state}
      id="colocar_retirada"
      title="Colocar como retirada"
      modalHandler={modalHandler}
      aditional_param="colocar_retirada"
      handleSubmit={handleSubmit}
      button_label="Guardar"
      button_disabled={false}
      button_loading={form_state}
    >
      <Grid container spacing={24}>
        <Typography>La orden será colocada como retirada.</Typography>
      </Grid>
    </ModalUI>
  );
};

export { ModalColocarRetirada };
